/* eslint-disable */
import { useQuery } from '@tanstack/react-query';
import { supabase } from '../supabase';

export function useDevCounts(enabled = true) {
  return useQuery({
    queryKey: ['dev-stage-counts'],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_dev_stage_counts');
      if (error) throw error;
      return data || {};
    },
    enabled,
    staleTime: 3 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
  });
}
